//import axios from 'axios';
import Global from '../../global';

// axios development only interceptors
// https://github.com/mzabriskie/axios#interceptors

/**
 * Strip baseURL from URL
 *
 * @param config Object
 * @returns String
 */
const getUrl = (config) => config.baseURL ? config.url.replace(config.baseURL, '') : config.url;
const getParams = (config) => config && config.params ? JSON.stringify(config.params) : '-';
const getData = config => config && config.data ? JSON.stringify(config.data) : '-';
const getResData = resData => resData ? JSON.stringify(resData) : '-';
const getMethod = config => config && config.method ? config.method.toUpperCase() : '-';
const getDuration = config => config && config.metadata ? `${(Date.now() - config.metadata.startTime)}` : '-';
const getSize = headers => headers && headers['content-length'] ? headers['content-length'] : '-';

function getRequestDetails(config) {
  let params = getParams(config);
  let data = getData(config);
  let method = getMethod(config);
  let url = getUrl(config);

  return `method[${method}] url[${url}] params[${params}] data[${data}]`;
}

function getResponseDetails(config, statusCode, headers, responseData = null) {
  let params = getParams(config);
  let data = getData(config);
  let method = getMethod(config);
  let url = getUrl(config);
  let resData = getResData(responseData);

  let duration = getDuration(config);
  let size = getSize(headers);

  return `method[${method}] url[${url}] status[${statusCode}] size[${size} bytes] time[${duration} ms] params[${params}] data[${data}] responseData[${resData}]`;
}

export function setAxiosInterceptors(axiosInstance) {

// Intercept all requests
  axiosInstance.interceptors.request.use(
    (config) => {
      Global.logger.info(`[REQ][intercept] ${getRequestDetails(config)}`);
      config.metadata = { startTime: Date.now() };
      return config;
    },
    (error) => {
      const { response } = error;
      if (response) {
        Global.logger.error(`[REQ][intercept] ${getRequestDetails(response.config)} ${error}`);
      } else {
        Global.logger.error(`[REQ][intercept] ${error}`);
      }
      return Promise.reject(error);
    }
  );

// Intercept all responses
  axiosInstance.interceptors.response.use(
    (response) => {
      Global.logger.info(`[RES][intercept] ${getResponseDetails(response.config, response.status, response.headers)}`);
      return response;
    },

    (error) => {
      const { response } = error;
      if (response) {
        Global.logger.error(`[RES][intercept] ${getResponseDetails(response.config, response.status, response.headers, response.data)} ${error}`);
      }

      return Promise.reject(error);
    }
  );

}
